import api from './api';

export default class ValeAlimentacaoService {
  constructor() {
    throw new Error('Não é possível instanciar ValeAlimentacaoService');
  }

  static verificarHabilitacao() {
    return api.get('vale-alimentacao/habilitado');
  }

  static carregarContexto() {
    return api.get('vale-alimentacao/contexto');
  }

  static visualizarAnexo(id) {
    return api.get('vale-alimentacao/detalhes/anexo', {
      params: { id },
      responseType: 'blob',
    });
  }

  static listaEmpresas() {
    return api.get('vale-alimentacao/empresas');
  }

  static salvar(item) {
    return api.post('vale-alimentacao', item);
  }

  static atualiza(id, item) {
    return api.put(`vale-alimentacao/${id}`, item);
  }

  static imprimirProtocolo(id) {
    return api.get(`vale-alimentacao/${id}/protocolo`, {
      responseType: 'blob',
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/valeAlimentacaoService.js